/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecondFactorViewResponse
 */
export interface SecondFactorViewResponse {
    /**
     * 
     * @type {string}
     * @memberof SecondFactorViewResponse
     */
    token: string;
}

/**
 * Check if a given object implements the SecondFactorViewResponse interface.
 */
export function instanceOfSecondFactorViewResponse(value: object): value is SecondFactorViewResponse {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function SecondFactorViewResponseFromJSON(json: any): SecondFactorViewResponse {
    return SecondFactorViewResponseFromJSONTyped(json, false);
}

export function SecondFactorViewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecondFactorViewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function SecondFactorViewResponseToJSON(json: any): SecondFactorViewResponse {
    return SecondFactorViewResponseToJSONTyped(json, false);
}

export function SecondFactorViewResponseToJSONTyped(value?: SecondFactorViewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

